import { Mutex } from "async-mutex";

/**
 * @description This class is used to prevent multiple calls to the same method at the same time.
 */
export class MutexByKey {
  private mutexInstances: Record<string, Mutex> = {};

  public acquire(key: string) {
    if (!this.mutexInstances[key]) {
      this.mutexInstances[key] = new Mutex();
    }
    return this.mutexInstances[key]!.acquire();
  }

  async acquireAll(keys: string[]) {
    return Promise.all(keys.map((key) => this.acquire(key)));
  }

  public waitForUnlock(key: string) {
    return this.mutexInstances[key]?.waitForUnlock();
  }

  waitForUnlockAll(keys: string[]) {
    return Promise.all(keys.map((key) => this.waitForUnlock(key)));
  }

  public isLocked(key: string) {
    return this.mutexInstances[key]?.isLocked();
  }

  public isLockedMany(keys: string[]) {
    return keys.some((key) => this.isLocked(key));
  }

  public release(key: string) {
    return this.mutexInstances[key]?.release();
  }

  async releaseAll(keys: string[]) {
    return Promise.all(keys.map((key) => this.release(key)));
  }
}
